module.exports = __webpack_public_path__ + "img/enderecos.6a058ce0.svg";